import angular, {IModule, IQProvider, IScope} from "angular";
import {registrerStandardRequestHeadereInterceptorForInjisering} from "./infrastruktur/StandardRequestHeadereInterceptor";
import {registrerApiVersjonResponsHeadereInterceptorForInjisering} from "./infrastruktur/ApiVersjonResponsHeadereInterceptor";
import {registrerAPIKallUrlInterceptorForInjisering} from "./infrastruktur/APIKallUrlhaandtering";
import {registrerRequestAutentiseringsInterceptorForInjisering} from "./infrastruktur/Tilgangshaandtering";
import {regNavn} from "./tjenester/tredjepartsTjenestenavn";
import {Autentisering} from "./tjenester/Autentisering";
import {RootScopeHjelper} from "./tjenester/RootScopeHjelper";
import {dekorer$logForInjisering, Logger, logHttpKallInterceptorForInjisering} from "./infrastruktur/Logging";
import {konverterIso8601DatoStrengTilDateAngularConfig} from "./infrastruktur/Iso8601DatostrengTilDate";
import {ILocalStorageServiceProvider} from "angular-local-storage";
import {Bygginformasjon} from "./infrastruktur/Bygginformasjon";
import {Konfigurasjon} from "./infrastruktur/Konfigurasjon";
import {ExceptionHandler} from "./infrastruktur/ExceptionHandler";
import {MeldingTilBruker} from "./tjenester/MeldingTilBruker";
import {UuidGenerator} from "./tjenester/UuidGenerator";
import {delegateService} from "./stoettefunk/angularHjelpemetoder";
import {Strenger} from "./tjenester/Strenger";
import {StrengMaler} from "./tjenester/StrengMaler";
import {Kontekst} from "./tjenester/Kontekst";
import {Datoformatering} from "./tjenester/Datoformatering";
import {IntroJsTjeneste} from "./tjenester/IntroJs";
import {Filer} from "./tjenester/Filer";
import {RessursPromisHjelp} from "./tjenester/ressurser/RessursPromisHjelp";
import {Throttle} from "./tjenester/Throttle";
import {Språklager} from "./tjenester/i18n/Spraaklager";
import {Språkvalg, SpråkvalgAvhengigheter} from "./tjenester/i18n/Spraakvalg";
import {LokaltDatalager} from "./tjenester/LokaltDatalager";
import {AutentiseringsRessurs} from "./tjenester/ressurser/AutentiseringsRessurs";
import {BrukerRessurs} from "./tjenester/ressurser/BrukerRessurs";
import {AvtaleRessurs} from "./tjenester/ressurser/AvtaleRessurs";
import {GruppeRessurs} from "./tjenester/ressurser/GruppeRessurs";
import {GruppeMedlemRessurs} from "./tjenester/ressurser/GruppeMedlemRessurs";
import {MedlemsrolleRessurs} from "./tjenester/ressurser/MedlemsrolleRessurs";
import {GruppeInvitasjonRessurs} from "./tjenester/ressurser/GruppeInvitasjonRessurs";
import {PlanRessurs} from "./tjenester/ressurser/PlanRessurs";
import {MøteRessurs} from "./tjenester/ressurser/MøteRessurs";
import {MøtedeltakerRessurs} from "./tjenester/ressurser/MøtedeltakerRessurs";
import {ProtokollRessurs} from "./tjenester/ressurser/ProtokollRessurs";
import {SakRessurs} from "./tjenester/ressurser/SakRessurs";
import {BeslutningRessurs} from "./tjenester/ressurser/BeslutningRessurs";
import {SakstypeRessurs} from "./tjenester/ressurser/SakstypeRessurs";
import {TemaRessurs} from "./tjenester/ressurser/TemaRessurs";
import {KommentarRessurs} from "./tjenester/ressurser/KommentarRessurs";
import {OppgaveRessurs} from "./tjenester/ressurser/OppgaveRessurs";
import {RevisjonsloggRessurs} from "./tjenester/ressurser/RevisjonsloggRessurs";
import {DokumentRessurs} from "./tjenester/ressurser/DokumentRessurs";
import {SøkRessurs} from "./tjenester/ressurser/SøkRessurs";
import {FavorittRessurs} from "./tjenester/ressurser/FavorittRessurs";
import {MalmøteRessurs} from "./tjenester/ressurser/MalmøteRessurs";
import {Møteprogresjonberegning} from "./tjenester/møte/Møteprogresjonberegning";
import {OppgaveTjeneste} from "./tjenester/modulspesifikke/OppgaveTjeneste";
import {BeslutningTjeneste as BeslutningTjenesteFelles} from "./tjenester/modulspesifikke/BeslutningTjeneste";
import {KommentarerTjeneste} from "./tjenester/modulspesifikke/KommentarTjeneste";
import {FavorittTjeneste} from "./tjenester/modulspesifikke/FavorittTjeneste";
import {relativDatoKortformatFilterForInjisering} from "./filter/relativDatoKortformatFilter";
import {avatarUrlFilterForInjisering} from "./filter/avatarUrlFilter";
import {serviceUrlFilterForInjisering} from "./filter/serviceUrlFilter";
import {foersteOrdForInjisering} from "./filter/foersteOrd";
import {oppgaveAvatarKlasseFilterForInjisering} from "./filter/oppgaveAvatarKlasseFilter";
import {strengMalFilterForInjisering} from "./filter/strengMalFilter";
import {telefonnummerFormatFilterForInjisering} from "./filter/telefonnummerFormat";
import {formaterDatoperiodeFilterForInjisering} from "./filter/formaterDatoperiodeFilter";
import {formaterDatoMedKlokkeslettFilterForInjisering} from "./filter/formaterDatoMedKlokkeslettFilter";
import {formaterDatoUtenKlokkeslettFilterForInjisering} from "./filter/formaterDatoUtenKlokkeslettFilter";
import {mFromNowUtenKlokkeslettFilterForInjisering} from "./filter/mFromNowUtenKlokkeslettFilter";
import {landkodeForInjisering} from "./filter/landkode";
import {avatarForInjisering} from "./direktiver/avatar";
import {ckeditorForInjisering} from "./direktiver/ckeditor";
import {bekreftKlikkForInjisering} from "./direktiver/bekreftKlikk";
import {lasterKnappForInjisering} from "./direktiver/lasterKnapp";
import {lasterKnappContainerForInjisering} from "./direktiver/lasterKnappContainer";
import {c3GrafForInjisering} from "./direktiver/c3Graf";
import {entitetIkonForInjisering} from "./direktiver/entitetIkon";
import {validerBrukernavnForInjisering} from "./direktiver/validerBrukernavn";
import {validerEpostOppdateresTilForInjisering} from "./direktiver/validerEpostOppdateresTil";
import {validerPassordForInjisering} from "./direktiver/validerPassord";
import {ValiderPassordResultatKontroller} from "./direktiver/validerPassordResultat";
import {erLikFeltForInjisering} from "./direktiver/erLikFelt";
import {featureForInjisering} from "./direktiver/feature";
import {kreverTilgangsrolleBrukerForInjisering} from "./direktiver/kreverTilgangsrolleBruker";
import {kreverTilgangsrolleGrpForInjisering} from "./direktiver/kreverTilgangsrolleGrp";
import {autofocusForInjisering} from "./direktiver/autofocus";
import {registrerXhrImgKomponent} from "./komponenter/xhrImg/xhrImg";
import {ArkivRessurs} from "./tjenester/ressurser/ArkivRessurs";
import {SøkTjeneste} from "./tjenester/modulspesifikke/SøkTjeneste";
import {C3TodeltPie} from "./komponenter/c3TodeltPie/c3TodeltPie";
import {AvstemningRessurs} from "./tjenester/ressurser/AvstemningRessurs";
import {OtpInputKontroller} from "./komponenter/otpInput/otpInput";
import {OtpOppsettRessurs} from "./tjenester/ressurser/OtpOppsettRessurs";
import {BrukerInaktivitetTjeneste} from "./tjenester/BrukerInaktivitet";
import {KlientinformasjonFraUserAgent} from "./tjenester/KlientinformasjonFraUserAgent";
import {CriiptoOIDCRessurs} from "./tjenester/ressurser/CriiptoOIDCRessurs";
import {formaterByteSomLesbarStrengFilterForInjisering} from "./filter/formaterByteSomLesbarStrengFilter";
import {benyttetAutentiseringsmetodeForInjisering} from "./filter/benyttetAutentiseringsmetode";
import {MoeteDeltakereStatusKomponent} from "./komponenter/moeteDeltakereStatus/moeteDeltakereStatus";
import {FellesAutentiseringsRessurs} from "./tjenester/ressurser/FellesAutentiseringsRessurs";
import {LogoKontroller} from "./komponenter/logo/logo";
import {PdfjsMeldingshåndtering} from "./tjenester/PdfjsMeldingshåndtering";
import {SystemmeldingRessurs} from "./tjenester/ressurser/SystemmeldingRessurs";
import {SystemMeldingKomponent} from "./komponenter/systemmelding/systemMelding";
import {DokumentsigneringRessurs} from "./tjenester/ressurser/DokumentsigneringRessurs";
import {ÅrshjulRessurs} from "./tjenester/ressurser/ÅrshjulRessurs";
import {tilLokalDatoIgnorerTsFilterForInjisering} from "./filter/tilLokalDatoIgnorerTsFilter";
import {UiRouterFasade} from "./infrastruktur/UiRouterFasade";
import {valideringsuttrykkInjisering} from "./direktiver/ngModelValideringsuttrykk";
import {InterWindowBus} from "./tjenester/InterWindowBus";
import {RessursFeilhåndtering} from "./tjenester/RessursFeilhåndtering";
import {Tidssonevalg} from "./tjenester/i18n/Tidssonevalg";
import {settIframeHeightVedLastingForInjisering} from "./direktiver/settIframeHeightVedLasting";
import {FlaggKontroller} from "./direktiver/flagg";
import {validerBrukernavnOppdateresTilForInjisering} from "./direktiver/validerBrukernavnOppdateresTil";
import {DokumentsigneringTjeneste} from "./tjenester/modulspesifikke/DokumentsigneringTjeneste";
import {registrerToggleKlasseVedStickyDirektiv} from "./direktiver/toggleKlasseVedSticky";
import {SkjemalåsRessurs} from "./tjenester/ressurser/SkjemalaasRessurs";
import {EnumOversettelser} from "./tjenester/i18n/EnumOversettelser";
import {AsynkOppgaveRessurs} from "./tjenester/ressurser/AsynkOppgaveRessurs";
import {DatoPeriodeFormateringKontroller} from "./komponenter/datoperiodeFormatering/datoperiodeFormatering";
import {DialogMock} from "felles/tjenester/Dialog";
import {DetteErNyttDialogMock} from "felles/tjenester/modulspesifikke/DetteErNyttDialog";
import {StandardRequestHeadereHttpInterceptorAvhengigheter} from "felles/infrastruktur/StandardRequestHeadereInterceptorAvhengigheter";
import {LokallagretAutentisertModel} from "felles/tjenester/LokallagretAutentisertModel";


export default function fellesModul(): IModule {
    const modul = angular.module('lederplan-felles', [
        require('angular-sanitize'),
        require('angular-moment'),
        require('angular-local-storage'),
        lastModul('ngCordova.plugins.nativeStorage', require('ngcordova-wrapper-nativestorage')),
        require('angular-resource'),
        require('angular-local-storage'),
        lastModul('gettext', require('angular-gettext'))
    ]);

    oppsett(modul);
    tjenester(modul);
    filter(modul);
    direktiver(modul);
    komponenter(modul);

    return modul;
}

function tjenester(modul: IModule) {
    modul
        .constant(Bygginformasjon.regNavn, Bygginformasjon.opprettBygginformasjon())
        .constant(Konfigurasjon.regNavn, Konfigurasjon.lastKonfigurasjonForMiljø(Konfigurasjon.avgjørForespurtMiljø(window.location)))

        //forvirret over forskjellen mellom factory, provider og service ?
        //les http://stackoverflow.com/questions/15666048/angular-js-service-vs-provider-vs-factory

        //erstatter angulars $exceptionHandler med vår egen for håndtering av logging og skjuling av lastindikator
        .factory(regNavn.ng.$exceptionHandler, ExceptionHandler.forInjiseringSomFactory())

        .service(Logger.regNavn, Logger.forInjisering())
        .service(RessursFeilhåndtering.regNavn, RessursFeilhåndtering.forInjisering())
        .service(MeldingTilBruker.regNavn, MeldingTilBruker.forInjisering())
        .factory(UuidGenerator.regNavn, [() => new UuidGenerator()])
        .service(regNavn.l.registrerElementKoblingerDelegat, delegateService(["vis", "settAktivtMaal"]))
        .service(Strenger.regNavn, Strenger.forInjisering())
        .service(StrengMaler.regNavn, StrengMaler.forInjisering())
        .service(Kontekst.regNavn, Kontekst.forInjisering())
        .service(Autentisering.regNavn, Autentisering.forInjisering())
        .service(LokallagretAutentisertModel.regNavn, LokallagretAutentisertModel.forInjisering())
        .service(Datoformatering.regNavn, Datoformatering.forInjisering())
        .service(IntroJsTjeneste.regNavn, IntroJsTjeneste.forInjisering())
        .service(Filer.regNavn, Filer.forInjisering())
        .service(RessursPromisHjelp.regNavn, RessursPromisHjelp.forInjisering())
        .service(RootScopeHjelper.regNavn, RootScopeHjelper.forInjisering())
        .service(Throttle.regNavn, Throttle.forInjisering())
        .service(Språklager.regNavn, Språklager.forInjisering())
        .service(Språkvalg.regNavn, Språkvalg.forInjisering())
        .service(EnumOversettelser.regNavn, EnumOversettelser.forInjisering())
        .service(Tidssonevalg.regNavn, Tidssonevalg.forInjisering())
        .service(LokaltDatalager.regNavn, LokaltDatalager.forInjisering())
        .service(BrukerInaktivitetTjeneste.regNavn, BrukerInaktivitetTjeneste.forInjisering())
        .service(InterWindowBus.regNavn, InterWindowBus.forInjisering())
        .service(KlientinformasjonFraUserAgent.regNavn, KlientinformasjonFraUserAgent.forInjisering())
        .service(PdfjsMeldingshåndtering.regNavn, PdfjsMeldingshåndtering.forInjisering())
        .service(StandardRequestHeadereHttpInterceptorAvhengigheter.regNavn, StandardRequestHeadereHttpInterceptorAvhengigheter.forInjisering)

        // ressurser
        .service(FellesAutentiseringsRessurs.regNavn, FellesAutentiseringsRessurs.forInjisering())
        .service(AutentiseringsRessurs.regNavn, AutentiseringsRessurs.forInjisering())
        .service(OtpOppsettRessurs.regNavn, OtpOppsettRessurs.forInjisering())
        .service(CriiptoOIDCRessurs.regNavn, CriiptoOIDCRessurs.forInjisering())
        .service(BrukerRessurs.regNavn, BrukerRessurs.forInjisering())
        .service(AvtaleRessurs.regNavn, AvtaleRessurs.forInjisering())
        .service(GruppeRessurs.regNavn, GruppeRessurs.forInjisering())
        .service(GruppeMedlemRessurs.regNavn, GruppeMedlemRessurs.forInjisering())
        .service(MedlemsrolleRessurs.regNavn, MedlemsrolleRessurs.forInjisering())
        .service(GruppeInvitasjonRessurs.regNavn, GruppeInvitasjonRessurs.forInjisering())
        .service(PlanRessurs.regNavn, PlanRessurs.forInjisering())
        .service(MøteRessurs.regNavn, MøteRessurs.forInjisering())
        .service(MøtedeltakerRessurs.regNavn, MøtedeltakerRessurs.forInjisering())
        .service(ProtokollRessurs.regNavn, ProtokollRessurs.forInjisering())
        .service(SakRessurs.regNavn, SakRessurs.forInjisering())
        .service(BeslutningRessurs.regNavn, BeslutningRessurs.forInjisering())
        .service(AvstemningRessurs.regNavn, AvstemningRessurs.forInjisering())
        .service(SakstypeRessurs.regNavn, SakstypeRessurs.forInjisering())
        .service(TemaRessurs.regNavn, TemaRessurs.forInjisering())
        .service(KommentarRessurs.regNavn, KommentarRessurs.forInjisering())
        .service(OppgaveRessurs.regNavn, OppgaveRessurs.forInjisering())
        .service(RevisjonsloggRessurs.regNavn, RevisjonsloggRessurs.forInjisering())
        .service(DokumentRessurs.regNavn, DokumentRessurs.forInjisering())
        .service(DokumentsigneringRessurs.regNavn, DokumentsigneringRessurs.forInjisering())
        .service(SøkRessurs.regNavn, SøkRessurs.forInjisering())
        .service(FavorittRessurs.regNavn, FavorittRessurs.forInjisering())
        .service(MalmøteRessurs.regNavn, MalmøteRessurs.forInjisering())
        .service(ArkivRessurs.regNavn, ArkivRessurs.forInjisering())
        .service(SystemmeldingRessurs.regNavn, SystemmeldingRessurs.forInjisering())
        .service(ÅrshjulRessurs.regNavn, ÅrshjulRessurs.forInjisering())
        .service(SkjemalåsRessurs.regNavn, SkjemalåsRessurs.forInjisering())
        .service(AsynkOppgaveRessurs.regNavn, AsynkOppgaveRessurs.forInjisering())

        //modulspesifikt
        .service(Møteprogresjonberegning.regNavn, Møteprogresjonberegning.forInjisering())
        .service(OppgaveTjeneste.regNavn, OppgaveTjeneste.forInjisering())
        .service(BeslutningTjenesteFelles.regNavn, BeslutningTjenesteFelles.forInjisering())
        .service(KommentarerTjeneste.regNavn, KommentarerTjeneste.forInjisering())
        .service(FavorittTjeneste.regNavn, FavorittTjeneste.forInjisering())
        .service(SøkTjeneste.regNavn, SøkTjeneste.forInjisering())
        DialogMock.registrerTjenester(modul)
        DetteErNyttDialogMock.registrerTjenester(modul)
        DokumentsigneringTjeneste.registrerTjenester(modul);
      ;
}

function filter(modul: IModule) {
    modul
        .filter('relativDatoKortformat', relativDatoKortformatFilterForInjisering())
        .filter('avatarUrl', avatarUrlFilterForInjisering())
        .filter('serviceUrl', serviceUrlFilterForInjisering())
        .filter('foersteOrd', foersteOrdForInjisering())
        .filter('oppgaveAvatarKlasse', oppgaveAvatarKlasseFilterForInjisering())
        .filter('strengMal', strengMalFilterForInjisering())
        .filter('telefonnummer', telefonnummerFormatFilterForInjisering())
        .filter('formaterDatoperiode', formaterDatoperiodeFilterForInjisering())
        .filter('formaterDatoMedKlokkeslett', formaterDatoMedKlokkeslettFilterForInjisering())
        .filter('formaterDatoUtenKlokkeslett', formaterDatoUtenKlokkeslettFilterForInjisering())
        .filter('mFromNowUtenKlokkeslett', mFromNowUtenKlokkeslettFilterForInjisering())
        .filter('tilLokalDatoIgnorerTs', tilLokalDatoIgnorerTsFilterForInjisering())
        .filter('byteSomStreng', formaterByteSomLesbarStrengFilterForInjisering())
        .filter('landkode', landkodeForInjisering())
        .filter('benyttetAutentiseringsmetode', benyttetAutentiseringsmetodeForInjisering())
        .filter("prettyJSON", () => json => JSON.stringify(json, null, " ")) // brukes kun til debug av json i html
}


function direktiver(modul: IModule) {
    modul
        .directive("avatar", avatarForInjisering())
        .directive("ckeditor", ckeditorForInjisering())
        .directive("bekreftKlikk", bekreftKlikkForInjisering())
        .directive("settIframeHeightVedLasting", settIframeHeightVedLastingForInjisering())
        .directive("lasterKnapp", lasterKnappForInjisering())
        .directive("lasterKnappContainer", lasterKnappContainerForInjisering())
        .directive("c3Graf", c3GrafForInjisering())
        .directive("entitetIkon", entitetIkonForInjisering())
        .directive("validerBrukernavn", validerBrukernavnForInjisering())
        .directive("validerEpostOppdateresTil", validerEpostOppdateresTilForInjisering())
        .directive("validerBrukernavnOppdateresTil", validerBrukernavnOppdateresTilForInjisering())
        .directive("validerPassord", validerPassordForInjisering())
        .directive("erLikFelt", erLikFeltForInjisering())
        .directive("valideringsuttrykk", valideringsuttrykkInjisering())
        .directive("feature", featureForInjisering())
        .directive("kreverTilgangsrolleBruker", kreverTilgangsrolleBrukerForInjisering())
        .directive("kreverTilgangsrolleGrp", kreverTilgangsrolleGrpForInjisering())
        .directive("autofocus", autofocusForInjisering());
    ValiderPassordResultatKontroller.registrerKomponent(modul);
    FlaggKontroller.registrerKomponent(modul);
    registrerToggleKlasseVedStickyDirektiv(modul);
}


function komponenter(modul: IModule) {
    registrerXhrImgKomponent(modul);
    C3TodeltPie.registrerKomponent(modul);
    MoeteDeltakereStatusKomponent.registrerKomponent(modul);
    OtpInputKontroller.registrerKomponent(modul);
    LogoKontroller.registrerKomponent(modul);
    SystemMeldingKomponent.registrerKomponent(modul);
    DatoPeriodeFormateringKontroller.registrerKomponent(modul);
}


function oppsett(modul: IModule) {
    modul

        //skrur av logging av unhandled rejections som ble innført i angularjs 1.6
        .config([regNavn.ng.$qProvider, Konfigurasjon.regNavn, function ($qProvider:IQProvider, konfigurasjon:Konfigurasjon) {
            if (konfigurasjon.miljø == 'prod') $qProvider.errorOnUnhandledRejections(false);
        }])

        //legger til faste http-headere nyttige for logging på serversiden
        .config(registrerStandardRequestHeadereInterceptorForInjisering())

        //legger til lesing av api-versjonsrelaterte headere i http-reponser, med varsel ved utdatert klient
        .config(registrerApiVersjonResponsHeadereInterceptorForInjisering())

        //håndtering av ikke-absolutte ressurser
        .config(registrerAPIKallUrlInterceptorForInjisering())

        //rolle-basert autorisasjon av states
        .run([UiRouterFasade.regNavn, (uiRouterFasade: UiRouterFasade) =>
            uiRouterFasade.registrerStateAutoriasasjon()])

        //gjør konfiguasjonstjenesten tilgjengelig på rootscope
        .run([RootScopeHjelper.regNavn, (rootScopeHjelper: RootScopeHjelper) =>
            rootScopeHjelper.eksponerKonfigurasjon()])

        //gjør konfiguasjonstjenesten tilgjengelig på rootscope
        .run([RootScopeHjelper.regNavn, (rootScopeHjelper: RootScopeHjelper) =>
            rootScopeHjelper.eksponerEkstraCssBodyKlasse()])

        /** Laster initielt språk/tidssone vhja web/mobil-spesifikk SpråkvalgAvhengigheter-implementasjon.
         * Initialiserer når bruker autentisert språk/tidssone fra verdier satt på bruker. */
        .run([regNavn.ng.$rootScope, Kontekst.regNavn, Språkvalg.regNavn, Tidssonevalg.regNavn, SpråkvalgAvhengigheter.regNavn, ($rootScope: IScope, kontekst:Kontekst, språkvalg: Språkvalg, tidssoner:Tidssonevalg, språkvalgAvhengigheter:SpråkvalgAvhengigheter) => {
            språkvalg.initSpråk(språkvalgAvhengigheter);
            tidssoner.initTidssone();

            $rootScope.$on(Autentisering.brukerAutentisertEvent, () => {
                språkvalg.oppdaterFraKontekst(kontekst);
                tidssoner.oppdaterFraKontekst(kontekst);
            });
        }])

        //jwt basert autentiesering av http requester
        .config(registrerRequestAutentiseringsInterceptorForInjisering())

        //legger til lokal debug-logging av httpkall, samt logging til server av langvarige http kall
        .config(logHttpKallInterceptorForInjisering())

        //dekorer angulars logger med vår som sender meldinger til server
        .config(dekorer$logForInjisering())

        //sørger for at datoer i json-respons konverteres til Date-objekter, merk at Date objekter blir konvertert til json-streng representasjon av angular
        .config(konverterIso8601DatoStrengTilDateAngularConfig())

        .config([regNavn.storage.localStorageServiceProvider, function (localStorageServiceProvider: ILocalStorageServiceProvider) {
            localStorageServiceProvider.setPrefix('lederplan');
        }])
    ;

}


/** for bruk ifbm angular moduler som ikke returnerer navnet på modulen ved require.
 * Eks lastModul('ngCordova.plugins.nativeStorage', require('ngcordova-wrapper-nativestorage')) */
export function lastModul(modulnavn:string, ...npmModulLasting){
    return modulnavn;
}
